import { Block } from '@/components/base/Block'
import { Text4 } from '@/components/base/Text'
import { useApp } from '@/hooks/useApp'
import { align } from '@/styles/display'
import { fontWeight } from '@/styles/font'
import spaceStyle from '@/styles/space'
import { type V1JobOfferAcceptanceStatusType } from 'mnvm-mypage-app-ts-if'

interface Props {
  detailInsertDate: string
  detailDueDate: string
  detailRemainingDueDate: string
  status: V1JobOfferAcceptanceStatusType
}

export const OfferAcceptanceDateSection = ({
  detailInsertDate,
  detailDueDate,
  detailRemainingDueDate,
  status
}: Props): JSX.Element => {
  const app = useApp()

  return (
    <Block margin={{ vertical: spaceStyle.M }} textAlign={align.LEFT}>
      <Text4
        textColor={app.theme.subTextColor}
        margin={{ horizontal: spaceStyle.NONE, bottom: spaceStyle.XS }}
        maxLines={1}
      >
        {`通知日時：${detailInsertDate}`}
      </Text4>

      <Text4
        textColor={app.theme.subTextColor}
        fontWeight={fontWeight.Bold}
        margin={{ horizontal: spaceStyle.NONE }}
        maxLines={1}
      >
        {`回答期限：${detailDueDate}`}
      </Text4>

      <Text4
        textColor={app.theme.redColor}
        margin={{ horizontal: spaceStyle.NONE }}
        maxLines={1}
      >
        {`${detailRemainingDueDate ?? ''}`}
      </Text4>
    </Block>
  )
}
